module.exports = __webpack_public_path__ + "static/media/icon_email.7460584d.svg";